import * as server from '../entries/pages/admin/users/_page.server.ts.js';

export const index = 37;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/admin/users/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/admin/users/+page.server.ts";
export const imports = ["_app/immutable/nodes/37.DT5psvAF.js","_app/immutable/chunks/Bzak7iHL.js","_app/immutable/chunks/CnGaPG_y.js","_app/immutable/chunks/DIeogL5L.js","_app/immutable/chunks/BBilxCvN.js","_app/immutable/chunks/7JdHMB9Z.js","_app/immutable/chunks/BqhvobEz.js","_app/immutable/chunks/_bkH3ryn.js","_app/immutable/chunks/Bu9wkQ5s.js","_app/immutable/chunks/B764PkgB.js","_app/immutable/chunks/BRzKQYUk.js","_app/immutable/chunks/DGA84RoI.js","_app/immutable/chunks/CKS908do.js"];
export const stylesheets = [];
export const fonts = [];
